/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Back_To_ListInputs */

const en_recipe_back_to_list = /** @type {(inputs: Recipe_Back_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All recipes`)
};

const de_recipe_back_to_list = /** @type {(inputs: Recipe_Back_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Rezepte`)
};

/**
* | output |
* | --- |
* | "All recipes" |
*
* @param {Recipe_Back_To_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_back_to_list = /** @type {((inputs?: Recipe_Back_To_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Back_To_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_back_to_list(inputs)
	return en_recipe_back_to_list(inputs)
});